// libraries
import { generateUri } from "@cloudspire/legacy-shared/src/libraries";

// constants
import { apiRouter } from "@cloudspire/legacy-shared/src/constants/router";

// normalizers
import { bookingEstimateParseSearch } from "../normalizers/booking/estimate";
import { buildBookingParseShow } from "../normalizers/booking";

// helpers
import { bookingMayEstimate } from "../helpers/booking/estimate";
import { normalizeParameterListForEstimate } from "../helpers/booking/normalizeParameterList";

export function bookingEstimateAside({ parameterList, room }) {
  let key = null;

  if (bookingMayEstimate({ parameterList })) {
    key = generateUri({
      router: apiRouter,
      name: "Api.Bookings.Action.Estimate",
      query: {
        allowedBookingLd: "1",
        ...normalizeParameterListForEstimate({
          parameterList,
          roomOptionList: room.optionList,
        }),
      },
    });
  }

  return {
    key,
    normalizer: bookingEstimateParseSearch,
  };
}

export function bookingEstimateBookingPage({ parameterList, room }) {
  let key = null;

  if (bookingMayEstimate({ parameterList })) {
    key = generateUri({
      router: apiRouter,
      name: "Api.Bookings.Action.Estimate",
      query: {
        allowedBookingLd: "1",
        ...normalizeParameterListForEstimate({
          parameterList,
          roomOptionList: room.optionList,
        }),
      },
    });
  }

  return {
    key,
    normalizer: bookingEstimateParseSearch,
  };
}

export function bookingPaymentStatusPage({ bookingReference, configuration }) {
  return {
    key: generateUri({
      router: apiRouter,
      name: "Api.Booking.Show",
      parameters: {
        bookingReference,
      },
    }),
    normalizer: buildBookingParseShow({ configuration }),
  };
}

export function bookingPaymentChoicePage({ bookingReference, configuration }) {
  return {
    key: generateUri({
      router: apiRouter,
      name: "Api.Booking.Show",
      parameters: {
        bookingReference,
      },
      query: {
        with_ancv_connect_info: "1",
      },
    }),
    normalizer: buildBookingParseShow({ configuration }),
  };
}
